<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <div class="content-page-header">
            <h5>
              <router-link to="/customers" style="color: #28084b">
                <i class="feather feather-arrow-left me-1"></i>
              </router-link>
              Customer Details
            </h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <router-link
                    class="btn btn-primary"
                    :to="`/edit-customer/` + customer.id"
                    ><i class="fa fa-edit me-2" aria-hidden="true"></i>Edit
                    Customer</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <div class="card customer-details-group">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-xl-3 col-lg-4 col-md-6 col-12">
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-user"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>Name</h6>
                      <p>{{ customer.name }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-6 col-12">
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-mail"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>Email Address</h6>
                      <p class="customer-mail">{{ customer.email }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="customer.phone"
                class="col-xl-3 col-lg-4 col-md-6 col-12"
              >
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-phone"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>Phone Number</h6>
                      <p>{{ `${customer.country_code}${customer.phone}` }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="customer.website"
                class="col-xl-3 col-lg-4 col-md-6 col-12"
              >
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-globe"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>Website</h6>
                      <p class="customer-mail">{{ customer.website }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="customer.address"
                class="col-xl-3 col-lg-4 col-md-6 col-12"
              >
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-map-pin"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>Address</h6>
                      <p>{{ customer.address }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="customer.state"
                class="col-xl-3 col-lg-4 col-md-6 col-12"
              >
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-move"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>Location</h6>
                      <p>{{ customer.state }} state, {{ customer.country }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="customer.whatsapp_number"
                class="col-xl-3 col-lg-4 col-md-6 col-12"
              >
                <div class="customer-details">
                  <div class="d-flex align-items-center">
                    <span class="customer-widget-icon d-inline-flex">
                      <i class="feather feather-send"></i>
                    </span>
                    <div class="customer-details-cont">
                      <h6>WhatsApp</h6>
                      <p>
                        {{
                          `${customer.country_code}${customer.whatsapp_number}`
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Inovices card -->
        <div class="position-relative">
          <div class="row d-flex flex-nowrap overflow-auto disable_line">
            <div class="col-xl-2 col-lg-4 col-6 d-flex">
              <div class="card inovices-card w-100">
                <div class="card-body">
                  <div class="dash-widget-header">
                    <span class="inovices-widget-icon bg-info-light">
                      <img src="@/assets/img/icons/receipt-item.svg" alt="" />
                    </span>
                    <div class="dash-count">
                      <div class="dash-title">Total Amount</div>
                    </div>
                  </div>
                  <div>
                    <div class="dash-widget-header">
                      <div class="dash-count">
                        <div class="dash-counts">
                          <p>
                            {{
                              summary?.total
                                ? useCurrency(summary?.total)
                                : useCurrency(0)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-4 col-6 d-flex">
              <div class="card inovices-card w-100">
                <div
                  class="card-body d-flex flex-column justify-content-between h-100"
                >
                  <div class="dash-widget-header">
                    <span class="inovices-widget-icon bg-green-light">
                      <img src="@/assets/img/icons/message-edit.svg" alt="" />
                    </span>
                    <div class="dash-count">
                      <div class="dash-title">Total Paid</div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="dash-widget-header">
                      <div class="dash-count">
                        <div class="dash-counts">
                          <p>
                            {{
                              summary?.amount_paid
                                ? useCurrency(summary?.amount_paid)
                                : useCurrency(0)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-4 col-6 d-flex">
              <div class="card inovices-card w-100">
                <div class="card-body">
                  <div class="dash-widget-header">
                    <span class="inovices-widget-icon bg-primary-light">
                      <img
                        src="@/assets/img/icons/transaction-minus.svg"
                        alt=""
                      />
                    </span>
                    <div class="dash-count">
                      <div class="dash-title">Total Pending</div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="dash-widget-header">
                      <div class="dash-count">
                        <div class="dash-counts">
                          <p>
                            {{
                              summary?.pending
                                ? useCurrency(summary?.pending)
                                : useCurrency(0)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-4 col-6 d-flex">
              <div class="card inovices-card w-100">
                <div class="card-body">
                  <div class="dash-widget-header">
                    <span class="inovices-widget-icon bg-warning-light">
                      <img src="@/assets/img/icons/archive-book.svg" alt="" />
                    </span>
                    <div class="dash-count">
                      <div class="dash-title">Total Overdue</div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="dash-widget-header">
                      <div class="dash-count">
                        <div class="dash-counts">
                          <p>
                            {{
                              summary?.amount_due
                                ? useCurrency(summary?.amount_due)
                                : useCurrency(0)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-4 col-6 d-flex">
              <div class="card inovices-card w-100">
                <div class="card-body">
                  <div class="dash-widget-header">
                    <span class="inovices-widget-icon bg-danger-light">
                      <img src="@/assets/img/icons/3d-rotate.svg" alt="" />
                    </span>
                    <div class="dash-count">
                      <div class="dash-title">Total Refunded</div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="dash-widget-header">
                      <div class="dash-count">
                        <div class="dash-counts">
                          <p>
                            {{
                              summary?.refunded
                                ? useCurrency(summary?.refunded)
                                : useCurrency(0)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Inovices card -->

        <div class="card-body">
          <b-tabs
            content-class=""
            active-nav-item-class="font-weight-bold bg-primary text-white"
          >
            <b-tab title="Invoice History" active
              ><span
                ><customerinvoice
                  @openPaymentModal="openPaymentModal"
                  @openModal="openInvoiceModal" /></span
            ></b-tab>
            <b-tab title="Estimates"
              ><span><customerestimates @openModal="openEstimateModal" /></span
            ></b-tab>
            <b-tab title="Expenses"
              ><span
                ><customerexpenses
                  @openEditModal="openEditModal"
                  @openViewModal="openViewModal"
                  @openModal="openModal" /></span
            ></b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- Delete Expense Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Expense</span>
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Expense</span
              >
              <span v-if="selectedAction === 'refund'">Refund Expense</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'refund'">refund</span>
              this expense?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteExpense"
                  class="w-100 btn btn-danger"
                  :disabled="isDeleting"
                >
                  <span
                    v-if="isDeleting"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isDeleting">Delete</span>
                  <span v-if="isDeleting">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'refund'"
                  @click="markAsRefunded"
                  class="w-100 btn btn-primary"
                  :disabled="isRefunding"
                >
                  <span
                    v-if="isRefunding"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isRefunding">Refund</span>
                  <span v-if="isRefunding">Refunding...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateExpense"
                  class="w-100 btn btn-primary"
                  :disabled="isDuplicating"
                >
                  <span
                    v-if="isDuplicating"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isDuplicating">Duplicate</span>
                  <span v-if="isDuplicating">Duplicating...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Expense Modal -->
  <ViewExpensemodal :expense="expense_view" />
  <EditExpensesModal
    :expenseID="expenseID"
    :form="form"
    @closeEditModal="closeEditModal"
  />
  <!-- Expenses -->

  <!-- Delete Invoice Modal -->
  <div class="modal custom-fade fade" id="delete-invoice_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Invoice</span>
              <span v-if="selectedAction === 'send'">Send Invoice</span>
              <span v-if="selectedAction === 'send-reminder'"
                >Send Reminder</span
              >
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Invoice</span
              >
              <span v-if="selectedAction === 'refund'">Refund Invoice</span>
              <span v-if="selectedAction === 'accept'">Accept Invoice</span>
              <span v-if="selectedAction === 'export'">Export Invoice</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'send'">send</span>
              <span v-if="selectedAction === 'send-reminder'"
                >send Reminder for</span
              >
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'refund'">refund</span>
              <span v-if="selectedAction === 'accept'">accept</span>
              <span class="fw-semibold ms-1">{{
                selectedItem.customer.name
              }}</span>
              Invoice?
            </p>
            <p v-if="selectedItem === null">
              Are you sure want to
              <span v-if="selectedAction === 'export'">export</span> Invoices?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Delete</span>
                  <span v-if="isLoading">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'send'"
                  @click="sendInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'send-reminder'"
                  @click="sendReminder"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'refund'"
                  @click="markAs('refunded')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Refund</span>
                  <span v-if="isLoading">Refunding...</span>
                </button>
                <button
                  v-if="selectedAction === 'accept'"
                  @click="markAs('accepted')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Accept</span>
                  <span v-if="isLoading">Accepting...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateInvoices"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Duplicate</span>
                  <span v-if="isLoading">Duplicating...</span>
                </button>
                <button
                  v-if="selectedAction === 'export'"
                  @click="exportInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Export</span>
                  <span v-if="isLoading">Exporting...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <recordpayment
    :form="payment_form"
    :selectedItem="selectedItem"
    @closePaymentModal="closePaymentModal"
  />

  <!-- Delete Estimate Modal -->
  <div class="modal custom-fade fade" id="delete-estimate_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Estimate</span>
              <span v-if="selectedAction === 'send'">Send Estimate</span>
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Estimate</span
              >
              <span v-if="selectedAction === 'reject'">Reject Estimate</span>
              <span v-if="selectedAction === 'accept'">Accept Estimate</span>
              <span v-if="selectedAction === 'export'">Export Estimate</span>
              <span v-if="selectedAction === 'convert'">Convert Estimate</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'send'">send</span>
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'reject'">reject</span>
              <span v-if="selectedAction === 'accept'">accept</span>
              <span v-if="selectedAction === 'convert'">convert</span>

              <span class="fw-semibold ms-1">{{
                selectedItem.customer.name
              }}</span>
              Estimate?
            </p>
            <p v-if="selectedItem === null">
              Are you sure want to
              <span v-if="selectedAction === 'export'">export</span> Estimates?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Delete</span>
                  <span v-if="isLoading">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'send'"
                  @click="sendEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'reject'"
                  @click="markEstimateAs('rejected')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Reject</span>
                  <span v-if="isLoading">Rejecting...</span>
                </button>
                <button
                  v-if="selectedAction === 'accept'"
                  @click="markEstimateAs('accepted')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Accept</span>
                  <span v-if="isLoading">Accepting...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Duplicate</span>
                  <span v-if="isLoading">Duplicating...</span>
                </button>
                <button
                  v-if="selectedAction === 'export'"
                  @click="exportEstimate"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Export</span>
                  <span v-if="isLoading">Exporting...</span>
                </button>
                <button
                  v-if="selectedAction === 'convert'"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Convert</span>
                  <span v-if="isLoading">Converting...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Estimate Modal -->
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import EditExpensesModal from "../finance/customer-edit-expenses.vue";
import ViewExpensemodal from "../finance/view-expense.vue";
import { formatDateStrings } from "@/assets/composables/date";
import { useCurrency } from "@/assets/composables/currency";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Modal } from "bootstrap";

const store = useStore();
const route = useRoute();
const modalInstance = ref(null);
const invoiceModalInstance = ref(null);
const estimateModalInstance = ref(null);
const paymentModal = ref(null);
const selectedItem = ref(null);
const isDuplicating = ref(null);
const isDeleting = ref(null);
const isRefunding = ref(null);
const selectedAction = ref(null);
const expenseID = ref(null);
const expense_view = ref(null);
const editModalInstance = ref(null);
const isLoading = ref(false);
const viewModalInstance = ref(null);

// expenses
const emptyEditForm = () => ({
  customer_id: "",
  date: "",
  amount: "",
  notes: "",
  recurring: "0",
  recurring_duration: {
    mode: null,
    value: null,
  },
  attachment: "",
});

const form = ref(emptyEditForm);

const openModal = async (data) => {
  selectedAction.value = await data.name;
  selectedItem.value = await data.data;
  modalInstance.value.show();
};
const closeModal = () => {
  modalInstance.value.hide();
};

const openViewModal = async (expense) => {
  expense_view.value = await expense;
  viewModalInstance.value.show();
};
const closeViewModal = () => {
  viewModalInstance.value.hide();
};

const openEditModal = async (expense) => {
  console.log(expense)
  expenseID.value = await expense.id;
  form.value = {
    customer_id: expense?.customer_id,
    date: formatDateStrings(expense.date),
    amount: expense.amount,
    currency: expense.currency,
    notes: expense.notes,
    currency: "NGN : Naira",
    recurring: expense.recurring,
    recurring_duration: {
      mode: expense.recurring_duration.mode,
      value: expense.recurring_duration.value,
    },
    attachment: "",
  };
  editModalInstance.value.show();
};
const closeEditModal = () => {
  editModalInstance.value.hide();
  store.dispatch("customer/getCustomerHistory", route.params.id);
};

const duplicateExpense = () => {
  isDuplicating.value = true;
  store
    .dispatch("expenses/duplicateExpense", selectedItem.value.id)
    .then(() => {
      isDuplicating.value = false;
      closeModal();
      store.dispatch("customer/getCustomerHistory", route.params.id);
    })
    .catch(() => {
      isDuplicating.value = false;
      closeModal();
    });
};

const markAsRefunded = () => {
  isRefunding.value = true;
  let data = {
    id: selectedItem.value.id,
    payload: {
      status: "refunded",
    },
  };
  store
    .dispatch("expenses/markAsRefunded", data)
    .then(() => {
      isRefunding.value = false;
      closeModal();
      store.dispatch("customer/getCustomerHistory", route.params.id);
    })
    .catch(() => {
      isRefunding.value = false;
      closeModal();
    });
};

const deleteExpense = () => {
  isDeleting.value = true;
  store
    .dispatch("expenses/deleteExpense", selectedItem.value.id)
    .then(() => {
      isDeleting.value = false;
      closeModal();
      store.dispatch("customer/deleteExpense", selectedItem.value.id);
    })
    .catch(() => {
      isDeleting.value = false;
      closeModal();
    });
};
// End expenses

// Invoices
const payment_form = ref({
  invoice_id: "",
  date: new Date(),
  method: "",
  amount: "",
  notify_client: false,
});

const resetPaymentForm = () => {
  payment_form.value = {
    invoice_id: "",
    date: new Date(),
    method: "",
    amount: "",
    notify_client: false,
  };
};

const openInvoiceModal = async (data) => {
  isLoading.value = false;
  selectedAction.value = await data.name;
  selectedItem.value = await data.data;
  invoiceModalInstance.value.show();
};
const closeInvoiceModal = () => {
  invoiceModalInstance.value.hide();
};
const openPaymentModal = async (invoice) => {
  isLoading.value = false;
  selectedItem.value = await invoice;
  payment_form.value.invoice_id = await invoice.id;
  payment_form.value.amount = await invoice.amount_due;
  paymentModal.value.show();
};
const closePaymentModal = () => {
  paymentModal.value.hide();
  getInvoices();
  resetPaymentForm();
};

const duplicateInvoices = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/duplicateInvoices", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeInvoiceModal();
      getInvoices();
    })
    .catch(() => {
      isLoading.value = false;
      closeInvoiceModal();
    });
};

const sendInvoice = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/sendInvoice", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeInvoiceModal();
      getInvoices();
    })
    .catch(() => {
      isLoading.value = false;
      closeInvoiceModal();
    });
};
const sendReminder = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/sendReminder", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeInvoiceModal();
    })
    .catch(() => {
      isLoading.value = false;
      closeInvoiceModal();
    });
};

const deleteInvoice = () => {
  isLoading.value = true;
  store
    .dispatch("invoices/deleteInvoice", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeInvoiceModal();
      store.dispatch("customer/deleteInvoice", selectedItem.value.id);
    })
    .catch(() => {
      isLoading.value = false;
      closeInvoiceModal();
    });
};

const markAs = (action) => {
  isLoading.value = true;
  let data = {
    id: selectedItem.value.id,
    payload: {
      status: action,
    },
  };

  store
    .dispatch("invoices/markAs", data)
    .then(() => {
      isLoading.value = false;
      closeInvoiceModal();
      getInvoices();
    })
    .catch(() => {
      isLoading.value = false;
      closeInvoiceModal();
    });
};

// Estimates
const openEstimateModal = async (data) => {
  isLoading.value = false;
  selectedAction.value = await data.name;
  selectedItem.value = await data.data;
  estimateModalInstance.value.show();
};
const closeEstimateModal = () => {
  estimateModalInstance.value.hide();
};

const duplicateEstimate = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/duplicateEstimate", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeEstimateModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeEstimateModal();
    });
};
const deleteEstimate = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/deleteEstimate", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeEstimateModal();
      store.dispatch("customer/deleteEstimate", selectedItem.value.id);
    })
    .catch(() => {
      isLoading.value = false;
      closeEstimateModal();
    });
};
const sendEstimate = () => {
  isLoading.value = true;
  store
    .dispatch("estimate/sendEstimate", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      closeEstimateModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeEstimateModal();
    });
};

const markEstimateAs = (action) => {
  isLoading.value = true;
  let data = {
    id: selectedItem.value.id,
    payload: {
      status: action,
    },
  };

  store
    .dispatch("estimate/markAs", data)
    .then(() => {
      isLoading.value = false;
      closeEstimateModal();
      getEstimates();
    })
    .catch(() => {
      isLoading.value = false;
      closeEstimateModal();
    });
};

const summary = computed(() => {
  return store.getters["customer/customer_history"].summary;
});

const getSummary = () => {
  store.dispatch("customer/getCustomerHistory", route.params.id);
};
const getInvoices = () => {
  store.dispatch("customer/getCustomerHistory", route.params.id);
};
const getEstimates = () => {
  store.dispatch("customer/getCustomerHistory", route.params.id);
};
const getCustomer = () => {
  store.dispatch("customer/getCustomer", route.params.id);
};

const customer = computed(() => {
  return store.getters["customer/mycustomer"];
});

onMounted(() => {
  getCustomer();
  getSummary();
  // Initiate modal
  modalInstance.value = new Modal(document.getElementById("delete_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  estimateModalInstance.value = new Modal(
    document.getElementById("delete-estimate_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
  invoiceModalInstance.value = new Modal(
    document.getElementById("delete-invoice_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
  editModalInstance.value = new Modal(document.getElementById("edit_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  viewModalInstance.value = new Modal(document.getElementById("view_modal"), {
    backdrop: "static",
    keyboard: false,
  });
  paymentModal.value = new Modal(document.getElementById("payment_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>
